var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"font-size-h3 font-weight-bold mt-3"},[_vm._v("Booking Summary")]),_c('div',{staticClass:"text-tertiary mb-2 text-center"},[_c('span',[_vm._v(_vm._s(_vm.formattedStartDay))]),_vm._v(", "),_c('span',[_vm._v(_vm._s(_vm.formattedStartDate))]),_c('br'),_c('span',[_vm._v("@ "+_vm._s(_vm.formattedStartTime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }